<template lang="pug">
.new-conveyor
  shForm(title="Nueva Transportadora")
</template>

<script>
import shForm from '@/components/pages/conveyor/Form'

export default {
  name: 'NewConveyor',

  components: { shForm }
}
</script>

<style lang="stylus">
.new-conveyor
  position relative
</style>



// WEBPACK FOOTER //
// src/components/pages/conveyor/New.vue